import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type delagateSigningState = "LOADING" | "READY" | "ERROR";

type delegateSigningTransactionObject = {
    transactions:{[stellar_id:string]:any}
}

const initialState:delegateSigningTransactionObject = {

   transactions:{},
}

const delegateSigning = createSlice({
  name: 'delegate_signing',
  initialState,
  reducers: {
    receivedDelegateSigningTx(state,action:PayloadAction<delegateSigningTransactionObject>){
      
    
    }
  },
  extraReducers:function(builder){
      
 }
});

// Reducer
export default delegateSigning.reducer;

// Actions
export const {receivedDelegateSigningTx} = delegateSigning.actions;


